import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import banneimage from "../../assets/images/interviewimg.jpeg";
import { topicsInterview } from "../../utils/Constant";
import { TrainingData } from "../../json/JSONdata";

export default function HospitalityTrainingSource() {
  const location = useLocation();
  const navigate = useNavigate();
  const category = location.pathname.split("/")[1];

  const HandleNavigateBlog = (hrBlogList) => {
    navigate(`/${category}/training-source/blog-list/${hrBlogList?.id}`, {
      state: { blog: hrBlogList }, // Pass allBlogs as state
    });
  };

  return (
    <div className="container-fluid">
      <div className="d-flex mt-3">
        <div className="heading-main mb-3 mx-1">
          <h2>Training Source</h2>
        </div>
      </div>

      {/* Banner Image Section */}

      {/* Interview Topics Section */}
      <div className="row g-4 mx-2 ">
        <div className="position-relative banner-container">
          <img
            src={banneimage}
            alt="Interview Banner"
            className="img-fluid w-100 banner-img"
          />
          <div className="banner-text">
            <h2>Training</h2>
            <p>
              Expert insights and strategies for effective training and skill
              development
            </p>
          </div>
        </div>
        <div>
          <p>
            Training is a structured learning process designed to enhance
            skills, knowledge, and competencies, ensuring individuals perform
            effectively in their roles. It goes beyond theoretical learning,
            offering hands-on experience and practical insights that foster
            professional growth and efficiency. Training programs can vary in
            format, from interactive workshops and e-learning modules to
            on-the-job training and formal certification courses. By blending
            expert guidance with real-world applications, training empowers
            individuals to adapt to industry demands, boost productivity, and
            achieve long-term career success.
          </p>
        </div>
        <div className="heading-main-h2 ">
          <h2>Training Categories</h2>
        </div>
        {TrainingData[0]?.categories?.map((training, index) => (
          <div key={index} className="col-md-4 col-sm-6 col-12">
            <div className="card d-flex flex-column h-100 shadow-sm">
              <img
                onClick={() => HandleNavigateBlog(training)}
                style={{ cursor: "pointer" }}
                src={training?.logo}
                alt="logo"
                className="card-img-top-interview p-0"
              />
              <div className="card-body flex-grow-1 d-flex flex-column card-content-partners">
                <h5 className="card-title">{training?.category}</h5>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* CSS for Responsive Banner */}
    </div>
  );
}
